var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C8.79469 24.5 5.78123 23.2518 3.51469 20.9853C1.24823 18.7188 0 15.7053 0 12.5C0 9.29469 1.24823 6.28123 3.51469 4.01469C5.78123 1.74823 8.79469 0.5 12 0.5C15.2053 0.5 18.2188 1.74823 20.4853 4.01469C22.7518 6.28123 24 9.29469 24 12.5C24 15.7053 22.7518 18.7188 20.4853 20.9853C18.2188 23.2518 15.2053 24.5 12 24.5ZM12 2.375C6.41705 2.375 1.875 6.91705 1.875 12.5C1.875 18.083 6.41705 22.625 12 22.625C17.583 22.625 22.125 18.083 22.125 12.5C22.125 6.91705 17.583 2.375 12 2.375ZM11.9531 13.3906C9.4718 13.3906 7.45312 11.372 7.45312 8.89062C7.45312 6.4093 9.4718 4.39062 11.9531 4.39062C14.4345 4.39062 16.4531 6.4093 16.4531 8.89062C16.4531 11.372 14.4345 13.3906 11.9531 13.3906ZM11.9531 6.26562C10.5057 6.26562 9.32812 7.44322 9.32812 8.89062C9.32812 10.338 10.5057 11.5156 11.9531 11.5156C13.4006 11.5156 14.5781 10.338 14.5781 8.89062C14.5781 7.44322 13.4006 6.26562 11.9531 6.26562ZM17.8927 18.8503C18.2933 18.5222 18.3521 17.9315 18.024 17.5309C16.6983 15.9125 14.7396 14.9844 12.6499 14.9844H11.5376C9.44794 14.9844 7.48917 15.9125 6.16355 17.531C5.83547 17.9315 5.8942 18.5222 6.2948 18.8503C6.69534 19.1784 7.28602 19.1196 7.61414 18.7191C8.58211 17.5372 10.0122 16.8594 11.5376 16.8594H12.6499C14.1753 16.8594 15.6054 17.5372 16.5734 18.719C16.7588 18.9453 17.0279 19.0625 17.2992 19.0625C17.5082 19.0625 17.7185 18.993 17.8927 18.8503Z",
    fill: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.512652b2da757f521a1b2b130c487319.svg";
export { ForwardRef as ReactComponent };